import { css } from 'styled-components';
import { TooltipPositions } from '../../enums/tooltip.js';
import '../../themes/alert.js';
import { borderRadiusXLarge } from '../../themes/borders.js';
import '../../themes/button.js';
import '../../themes/checkbox.js';
import '../../themes/divider.js';
import '../../themes/dropdown.js';
import '../../themes/fieldset.js';
import { fontFamilyBook } from '../../themes/fonts.js';
import '../../themes/input.js';
import '../../themes/list.js';
import '../../themes/listbox.js';
import '../../themes/loader.js';
import '../../themes/option.js';
import '../../themes/popout.js';
import '../../themes/switch.js';
import '../../themes/themes.js';
import '../../themes/tooltip.js';

const baseTooltipStyle = css`
  box-sizing: border-box;
  display: inline-block;
  position: relative;

  &::after,
  &::before {
    position: absolute;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease;
  }

  &::after {
    content: '';
    width: 0;
    height: 0;
  }

  &::before {
    border-radius: ${borderRadiusXLarge}px;
    content: attr(data-tooltip);
    font-family: ${fontFamilyBook};
    font-size: 13px;
    line-height: 21px;
    padding: 10px 13px;
    text-align: center;
    white-space: nowrap;
    z-index: 2;
  }

  &:hover {
    &::after,
    &::before {
      opacity: 1;
      visibility: visible;
    }
  }
`;
/**
 * Get Styled Component tooltip color styles
 * @param options getTooltipLookOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getTooltipLook = (options)=>{
    const { look } = options;
    return css`
    &::before {
      background-color: ${({ theme })=>theme.tooltip[look].backgroundColor};
      color: ${({ theme })=>theme.tooltip[look].textColor};
    }
  `;
};
/**
 * Get Styled Component tooltip position styles
 * @param options GetTooltipPositionOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getTooltipPosition = (options)=>{
    const { look, position } = options;
    switch(position){
        case TooltipPositions.Bottom:
            {
                return css`
        &::after,
        &::before {
          top: 100%;
          left: 50%;
          transform: translate(-50%);
          margin-top: 10px;
        }
        &::after {
          margin-top: 3px;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-bottom: 7px solid ${({ theme })=>theme.tooltip[look].backgroundColor};
        }
        ${getTooltipLook({
                    look
                })}
      `;
            }
        case TooltipPositions.Left:
            {
                return css`
        &::after,
        &::before {
          top: 50%;
          right: 100%;
          transform: translate(0, -50%);
          margin-right: 10px;
        }
        &::after {
          margin-right: 3px;
          border-top: 8px solid transparent;
          border-left: 7px solid ${({ theme })=>theme.tooltip[look].backgroundColor};
          border-bottom: 8px solid transparent;
        }
        ${getTooltipLook({
                    look
                })}
      `;
            }
        case TooltipPositions.Right:
            {
                return css`
        &::after,
        &::before {
          top: 50%;
          left: 100%;
          transform: translate(0, -50%);
          margin-left: 10px;
        }
        &::after {
          margin-left: 3px;
          border-top: 8px solid transparent;
          border-right: 7px solid ${({ theme })=>theme.tooltip[look].backgroundColor};
          border-bottom: 8px solid transparent;
        }
        ${getTooltipLook({
                    look
                })}
      `;
            }
        default:
            {
                // TooltipPositions.Top
                return css`
        &::after,
        &::before {
          bottom: 100%;
          left: 50%;
          transform: translate(-50%);
          margin-bottom: 10px;
        }
        &::after {
          margin-bottom: 3px;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-top: 7px solid ${({ theme })=>theme.tooltip[look].backgroundColor};
        }
        ${getTooltipLook({
                    look
                })}
      `;
            }
    }
};

export { baseTooltipStyle, getTooltipLook, getTooltipPosition };
//# sourceMappingURL=tooltip.js.map
